// extracted by mini-css-extract-plugin
export var avatarContainer = "_4s-0";
export var gray = "_4s-f";
export var green = "_4s-c";
export var icon = "_4s-9";
export var image = "_4s-1";
export var lg = "_4s-6";
export var md = "_4s-5";
export var presenceDot = "_4s-b";
export var red = "_4s-d";
export var sm = "_4s-4";
export var status = "_4s-a";
export var xl = "_4s-7";
export var xs = "_4s-3";
export var xxl = "_4s-8";
export var xxs = "_4s-2";
export var yellow = "_4s-e";